import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AdminGuard } from './shared/guards/admin.guard'
// import { CallbackSigninComponent } from './component/callback-signin/callback-signin.component';
import { PageNotFoundComponent } from 'src/app/page-not-found/page-not-found.component';
const routes: Routes = [
  // {path:'login',component:LoginComponent},
  {
    path: '',
    loadChildren: () => import('src/app/home-page/home-page.module').then(m => m.HomePageModule) ,
    canActivate: [AdminGuard ]
  },
  {
    path: 'login',
    loadChildren: () => import('src/app/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'callback-signin',
    loadChildren: () => import('src/app/auth/auth.module').then(m => m.AuthModule)
  },
  { path: '**', 
  component: PageNotFoundComponent
 }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
